import * as React from 'react';
import { useState } from 'react'
import { useCartStore } from 'src/hooks/cart';
import store from 'src/storeWire';
import { SET_ADD_CART_DATA } from 'src/store/slice/model/Cart';
import Helper from 'src/support/Helper';
import CommonCart from "src/component/Global/Cart/Common";
import { system_notification } from 'src/store/slice/system';
import { useProductPricingStore } from 'src/hooks/productPricing';

const CartItemReplacePopup = (props) => {
    const { SetStatus, data, isFrom } = props;
    let cartReplaceItem = data.cartReplaceItem
    const [{ }, { }, { replace_cart_in_Bulk }] = useCartStore();
    const [{ pricingList }, { }, { }] = useProductPricingStore();
    const [loader, setLoader] = useState(false)
    const pricing = pricingList

    const replaceCartItem = async () => {
        setLoader(true)
        /**
         * Conditionally open invetory alert if backorder available
         * Author: Devanshi Patel
         */
        // Pankaj - Add Cart Replaced price for move-to-cart
        cartReplaceItem = { ...cartReplaceItem, cartReplacedPrice: new CommonCart().getCurrentPriceByQuantityAndPriceArray(getPricing(cartReplaceItem.ERPMFRPartNumber, cartReplaceItem.partNumber, cartReplaceItem.ERPPartNumberModified), cartReplaceItem.totalQuantity).marketPrice };
        if (cartReplaceItem.backOrderQuantity > 0) {
            /**
             * isManuallyAddCart is used for confirm it from manually add cart or normal cart
             * isReplaceCart is used for confirm invetory alert is for replace cart item or add to cart item
             * Author: Devanshi Patel
             */
            store.dispatch(system_notification({
                name: 'InventoryAlertForAddToCartPopup',
                data: {
                    ...cartReplaceItem,
                    isReplaceCart: true,
                    productAddedToCartCallback: data.productAddedToCartCallback,
                    isManuallyAddCart: data.customAddToCartButton,
                    isFrom:isFrom
                },
            }));
            
            setLoader(false)
        } else {
            await replace_cart_in_Bulk(cartReplaceItem);
            setTimeout(() => {
                setLoader(false)
            }, 1500);
        }
    }

    const getUnitPrice = () => {
        return Helper.getFormatNumber(Number(new CommonCart().getCurrentPriceByQuantityAndPriceArray(getPricing(cartReplaceItem.ERPMFRPartNumber, cartReplaceItem.partNumber, cartReplaceItem.ERPPartNumberModified), cartReplaceItem.totalQuantity).marketPrice), window.mct, window.mcs, 5);
    };

    const getPricing = (ERPMFRPartNumber, ERPPartNumber,ERPPartNumberModified) => {
        ERPPartNumber = ERPPartNumberModified ? '' : ERPPartNumber; 
        if (pricing[ERPMFRPartNumber + '-' + ERPPartNumber] !== undefined) {
            return pricing[ERPMFRPartNumber + '-' + ERPPartNumber];
        }
        return [];
    };

    return (
        <>
            <div className="avnet-modal modal-680">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                            store.dispatch(SET_ADD_CART_DATA(false))
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">Customer Part Number</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <p>This item exists with a different Customer Part Number (CPN) in your cart. Do you want to replace it with the CPN shown below?</p>

                        <div className="table-responsive mb-4">
                            <table className="bs5 table table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th><span>Product</span></th>
                                        <th><span>CPN</span></th>
                                        <th><span>Manufacturer</span></th>
                                        <th><span>Quantity</span></th>
                                        <th><span>Price</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="align-middle">
                                        <td>
                                            <div className='font-12'>{cartReplaceItem.ERPMFRPartNumber && cartReplaceItem.ERPMFRPartNumber}</div>
                                        </td>
                                        <td>
                                            <div className='font-12'>{cartReplaceItem.CUSTOMER_PART_NUMBER && cartReplaceItem.CUSTOMER_PART_NUMBER}</div>
                                        </td>
                                        <td>
                                            <div className='font-12'>{cartReplaceItem.manufacturerName && cartReplaceItem.manufacturerName}</div>
                                        </td>
                                        <td>
                                            <div className='font-12'>{cartReplaceItem.totalQuantity && cartReplaceItem.totalQuantity}</div>
                                        </td>
                                        <td>
                                            <div className='font-12'>{getUnitPrice()}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary w145"
                                data-bs-toggle="modal"
                                onClick={() => {
                                    SetStatus(false)
                                    store.dispatch(SET_ADD_CART_DATA(false))
                                }}>
                                Cancel
                            </button>
                            {loader &&

                                <button type="submit" className="bs5 btn btn-primary w145"
                                    data-bs-toggle="modal"
                                    disabled={true}
                                >
                                    <i className="fa fa-spinner fa-spin" />
                                </button>
                            }

                            {!loader &&

                                <button type="submit" className="bs5 btn btn-primary w145"
                                    data-bs-toggle="modal"
                                    onClick={() => {
                                        replaceCartItem()
                                    }}>
                                    Replace
                                </button>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CartItemReplacePopup;